<template>
    <el-dialog class="dialog" title="上传文件" v-if="dialogVisible" :visible.sync="dialogVisible" width="600px" top="5vh">
        <el-upload
            action= "#"
            :auto-upload="false"
            :multiple="true"
            :show-file-list="true"
            :limit="maxNum"
            :file-list="listObj"
            :on-remove="handleRemove"
            :on-error="handleError"
            :on-exceed="handleExceed"
            :on-change="fileChange"
            accept=".xls;*.xlsx;"
            >
            <el-button :disabled="hideUpload" size="small" type="primary">选择文件</el-button>
            <div slot="tip" class="el-upload__tip" style="font-size:10px;margin-top:5px;line-height: 16px;">仅允许导入“xls”或“xlsx”格式文件</div>
        </el-upload>

        <div class="dialog-butn-box" style="margin: 20px 10px 10px">
            <el-button size="small" @click="dialogVisible = false">取 消</el-button>
            <el-button size="small" type="primary" :loading="dialogLoading" @click="handleSave">上 传</el-button>
        </div>

    </el-dialog>
</template>

<script>
import { ajax_uploadExcel } from '@Sys~/api/sys'
export default {
    props: {
        maxNum: { // 最大上传文件数量
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            dialogVisible: false,
            hideUpload: false,
            listObj: [], // 接收上传文件信息
            dialogLoading: false
        }
    },
    methods: {
        init() {
            this.dialogVisible = true
            this.hideUpload = false
            this.listObj = []
            this.dialogLoading = false
        },

        // 删除上传文件
        handleRemove(file , fileList) {
            this.listObj = fileList
            this.hideUpload = this.listObj.length >= this.maxNum;
        },

        // 上传失败
        handleError(err) {
            this.$message({
            message: '上传失败',
            type: 'error'
            })
        },

         // 监听上传
        fileChange(file, fileList) {
            // console.log('监听上传图片fileList==========', fileList)
            this.listObj = fileList
            this.hideUpload = this.listObj.length >= this.maxNum;
            // this.$emit('uploadBack',this.listObj)
        },

        // 超出上传数量限制
        handleExceed() {
            this.$message.warning('最多只能上传'+ this.maxNum +'文件')
        },

        // 确定上传
        handleSave() {
            // console.log(this.listObj)
            // 验证文件个数 > 0
            if(this.listObj.length < 1) {
                this.$message.warning("请选择上传文件")
                return false
            }

            // 验证文件格式
            const types = ["xls", "xlsx"]
            let noPass = false
            this.listObj.forEach(item => {
                const names = item.name.split(".")
                const suffix = names[names.length - 1] // 获取文件后缀名
                // console.log(suffix)
                if(types.indexOf(suffix.toLowerCase()) == -1) {
                    this.$message.warning("所选文件 " + item.name + " 格式不符");
                    this.noPass = true
                }
            })

            if(!this.noPass) {
                this.dialogLoading = true
                let formData = new FormData()
                formData.append('modifyAccount', this.$store.getters.userId)

                this.listObj.forEach(item => {
                    // console.log(item)
                    formData.append('uploadFile', item.raw)
                })

                // console.log('最终提交：',formData)

                ajax_uploadExcel(formData).then(response => {
                    this.dialogLoading = false
                    if(response.code == 1) {
                        this.dialogVisible = false
                        this.$emit('rebrushList')
                    }
                })
            }
        }


    }
}
</script>

<style lang="scss" scoped>
    .dialog{
        ::v-deep .el-dialog__body{
            padding: 10px;
            text-align: center;
        }
    }
</style>